import React from 'react'
import { css } from '@emotion/css'
import { VulnerabilityPolicy } from '../index'
import { DeleteAction } from '../actions/delete-action'
import { RenderDialogProps } from '../../../legacy-design-system/action/confirmation-action'
import { DeleteDialog } from '../actions/delete-dialog'
import { Role } from '@contrast-security-inc/base-types'

export function ActionsCell({
  dataE2e,
  rowData,
  organizationID,
  organizationRole,
  refetch
}: {
  readonly organizationID: string
  readonly organizationRole: Role
  readonly refetch: () => Promise<any>
  readonly rowData: VulnerabilityPolicy
  readonly dataE2e?: string
}) {
  const { id, name } = rowData
  return (
    <div
      data-e2e={dataE2e}
      className={css`
        display: flex;
        justify-content: center;
        align-items: center;
      `}
    >
      <DeleteAction
        isActionValid={true}
        role={organizationRole}
        renderDialog={({ isOpen, closeDialog }: RenderDialogProps) => (
          <DeleteDialog
            isOpen={isOpen}
            closeDialog={closeDialog}
            organizationUuid={organizationID}
            policyID={id}
            policyName={name}
            refresh={refetch}
          />
        )}
      />
    </div>
  )
}
